<template lang="html">
  <div class="order-detail-wrapper" v-loading="loading">
    <div class="top-content same-content">
      <div class="title">
        订单信息
      </div>
      <div class="content-detail">
        <div class="content-detail-wrapper">
          <div class="detail-item">
            <span>订单号：</span><span>{{ details.orderNo }}</span>
          </div>
          <div class="detail-item">
            <span>状态：</span><span>{{ details.status | statusFormat }}</span>
          </div>
          <div class="detail-item">
            <span>总运费：</span><span>{{ details.totalMoney }}</span>
          </div>
          <div class="detail-item">
            <span>单价：</span><span>{{ details.price }}</span>
          </div>
          <div class="detail-item">
            <span>代付费：</span><span>{{ details.paidMoney || '' }}</span>
          </div>
          <div class="detail-item">
            <span>是否开发票：</span
            ><span>{{ details.isBilling ? "是" : "否" }}</span>
          </div>
          <div class="detail-item">
            <span>是否货到付款：</span
            ><span>{{ details.sbustitude ? "是" : "否" }}</span>
          </div>
          <div class="detail-item">
            <span>路线：</span
            ><span>{{
            (details.cityFrom || '') +
            (details.districtFrom || '') +
                "-" +
            (details.cityTo || '') +
            (details.districtTo || '')
            }}</span>
          </div>
          <div class="detail-item">
            <span>创建时间：</span
            ><span>{{ details.createTime | timeFormat }}</span>
          </div>
          <div class="detail-item">
            <span>提货时间：</span
            ><span>{{ details.deliveryTime | timeFormat }}</span>
          </div>
          <div class="detail-item">
            <span>确认送达时间：</span
            ><span>{{ details.completeTime | timeFormat }}</span>
          </div>
        </div>
        <div class="handling-content">
          <div class="handling-title">
            货物总计：<span
              >{{ details.totalWeight }}吨；{{ details.pickupDrop }}</span
            >
          </div>
          <div class="handling-detail">
            <div
              class="handling-item"
              v-for="(childItem, childIndex) in details.goods"
              :key="childIndex"
            >
              <div class="key">
                {{ childIndex + 1 }}
              </div>
              <div class="goods-name">
                {{ isOld ? childItem.category.name : childItem.goodsName }}
              </div>
              <div class="goods-weight">
                {{ isOld ? childItem.count : childItem.weight }}吨
              </div>
              <div class="route-details">
                <span>{{ childItem.addressFrom }}</span>
                <i class="el-icon-right"></i>
                <span>{{ childItem.addressTo }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-content same-content">
      <div class="title">
        其他信息
      </div>
      <div class="content-detail">
        <div class="content-detail-wrapper">
          <div class="detail-item">
            <span>交易员姓名：</span
            ><span>{{ details.scheduler && details.scheduler.name }}</span>
          </div>
          <div class="detail-item">
            <span>交易员电话：</span
            ><span>{{ details.scheduler && details.scheduler.phone }}</span>
          </div>
          <div class="detail-item">
            <span>车辆信息：</span
            ><span>{{ details.truck && getTruckInfo(details.truck) }}</span>
          </div>
          <div class="detail-item detail-item-diff">
            <span class="detail-label">备注：</span
            ><span>{{ details.remark }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="details-btn-wrap">
      <template v-if="!isOld">
        <el-button
          type="primary"
          v-if="isDelivered"
          @click="sureService"
          :key="1"
          >确认送达</el-button
        >
        <template v-if="isButton">
          <el-button type="primary" @click="confirmQuotation" :key="2"
            >确认报价</el-button
          >
          <el-button @click="refuseQuotation" :key="3">拒绝报价</el-button>
        </template>
      </template>
      <template v-if="isTrajectory">
        <el-button type="primary" @click="viewingPath" :key="4"
          >查看轨迹</el-button
        >
        <el-button type="primary" @click="checkReceipt" :key="5"
          >查看回单</el-button
        >
      </template>
    </div>

    <!-- 拒绝报价弹窗 -->
    <refuse-dialog
      :dialogVisible.sync="refuseVisible"
      :id="details._id"
      @success="getDetail"
    />
    <!-- 查看回单弹窗 -->
    <receipt-dialog
      :dialogVisible.sync="receiptVisible"
      :orderNo="details.orderNo"
      :isOld="!!isOld"
      :receiptArr="receiptArr"
    />
    <!-- 查看轨迹弹窗 -->
    <view-path-dialog
      :dialogVisible.sync="viewPathVisible"
      :orderNo="details.orderNo"
    />
  </div>
</template>

<script>
import qs from "qs";
import refuseDialog from "./components/refuseDialog";
import receiptDialog from "./components/receiptDialog";
import viewPathDialog from "./components/viewPathDialog";
export default {
  data() {
    return {
      id: this.$route.params.id,
      details: {},
      isDelivered: false,
      isButton: false,
      isTrajectory: false,
      refuseVisible: false,
      receiptVisible: false,
      viewPathVisible: false,
      isOld: this.$route.query.isOld,
      loading: false,
      receiptArr: []
    };
  },
  computed: {},
  created() {
    this.getDetail();
  },
  methods: {
    getTruckInfo(val) {
      return val.map(item => item.plateNo).join();
    },
    viewingPath() {
      this.viewPathVisible = true;
    },
    checkReceipt() {
      if (this.isOld) {
        this.receiptArr = this.details.receiptPhoto;
      } else {
        this.receiptArr = [];
      }
      this.receiptVisible = true;
    },
    async getDetail() {
      this.loading = true;
      let { data } = await this.$http.get(
        `/shipper/order-shipper/${
          this.isOld ? "former-order-detail" : "detail"
        }`,
        {
          params: {
            id: this.id
          }
        }
      );
      this.details = data;
      let { status } = data;
      this.isDelivered = status === 600;
      this.isButton = status === 200;
      this.isTrajectory = status > 300 && status <= 700;
      await this.$nextTick();
      this.loading = false;
    },
    refuseQuotation() {
      this.refuseVisible = true;
    },
    async confirmQuotation() {
      await this.$myConfirm("确认报价吗", this);
      await this.$http.post(
        "/shipper/order-shipper/confirm",
        qs.stringify({
          id: this.details._id,
          confirm: 1
        })
      );
      this.$message.success("操作成功");
      this.getDetail();
    },
    async sureService() {
      await this.$myConfirm("确认提交吗", this);
      await this.$http.get(
        "/shipper/order-shipper/confirm-delivered?orderId=" + this.details._id
      );
      this.$message.success("操作成功");
      this.getDetail();
    }
  },
  watch: {},
  components: {
    refuseDialog,
    viewPathDialog,
    receiptDialog
  }
};
</script>

<style lang="scss">
.order-detail-wrapper {
  margin-top: 30px;
  .same-content {
    border: 1px solid #e0e0e0;
    padding: 20px;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    .content-detail {
      padding: 20px 30px 10px 30px;
      .content-detail-wrapper {
        display: flex;
        flex-wrap: wrap;
        .detail-item {
          width: 50%;
          line-height: 36px;
          font-size: 14px;
          &.detail-item-diff {
            width: 100%;
            display: flex;
            .detail-label {
              width: 62px;
            }
          }
        }
      }
    }
    .handling-content {
      background: #ebf2fd;
      margin-top: 20px;
      font-size: 14px;
      padding-bottom: 10px;
      .handling-title {
        padding: 20px 0 10px 20px;
        span {
          color: #00a7f7;
        }
      }
      .handling-detail {
        margin-left: 30px;
        .handling-item {
          border-bottom: 1px solid #d8d8d8;
          padding: 20px 10px;
          display: flex;
          align-items: center;
          &:last-child {
            border-bottom: none;
          }
          .key {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            background: #00a7f7;
            color: #fff;
            margin: 0 10px;
          }
          .goods-name {
            margin-right: 20px;
            margin-left: 40px;
            width: 100px;
          }
          .goods-weight {
            margin-right: 20px;
            width: 60px;
          }
          .route-details {
            flex: 1;
            text-align: center;
            align-items: center;
            i {
              margin: 0 10px;
            }
          }
        }
      }
    }
  }

  .top-content {
  }
  .bottom-content {
    border-top: none;
  }
  .details-btn-wrap {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 20px;
    .el-button {
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/order/detail/index.vue